import { Outlet } from "react-router-dom";

const Menu = () => {

  return <Outlet />
}

export default Menu;